<div class="modal-header" appCustomAutofocus style="background-color:#f5f5f5;">
    <h5 class="modal-title" *ngIf="Languages['Balance History'] == null">{{leaveCode.LeaveCodeDescription}} Balance History</h5>
    <h5 class="modal-title" *ngIf="Languages['Balance History'] != null">{{leaveCode.LeaveCodeDescription}} {{Languages["Balance History"]["TranslateLabel"]}}</h5>
</div>
<div class="modal-body">
    <div class="row" *ngIf="hrTimeOffMessage">
        <div class="col-lg-12 col-md-12 col-12">
            <p><quill-view [content]="hrTimeOffMessage"></quill-view></p>
        </div>
    </div>
    <hr *ngIf="hrTimeOffMessage" />

    <div class="row" style="align-content:center;">
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Annual Allotment'] == null">Annual Allotment:</div>
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Annual Allotment'] != null">{{Languages["Annual Allotment"]["TranslateLabel"]}}:</div>
        <div class="col-md-1 col-1"></div><span>{{leaveCode.AnnualAllotment | daysAndHours:settings.timeOffUnits:stdWorkdayHours:false:true}}</span><br />
    </div>
    <hr />
    <div class="row" style="margin-bottom: 12px;">
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Starting Bal'] == null">{{year}} Starting Bal as of {{leaveCode.AvailBalDateDisplay}}:</div>
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Starting Bal'] != null">{{year}} {{Languages["Starting Bal"]["TranslateLabel"]}}:</div>
        <div class="col-md-1 col-1"></div><span>{{leaveCode.PrevRollOver | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
    </div>
    <div class="row" style="margin-bottom: 12px;">
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Accrued'] == null">Accrued as of {{leaveCode.AccrualAsOfDateDisplay}}:</div>
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Accrued'] != null">{{Languages["Accrued"]["TranslateLabel"]}}:</div>
        <div class="col-md-1 col-1" style="text-align: right;">+</div><span>{{leaveCode.YTDAccrued | daysAndHours:settings.timeOffUnits:stdWorkdayHours}} </span><br />
    </div>
    <div class="row">
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Since Last Reset Date:'] == null">Since Last Reset Date:</div>
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Since Last Reset Date:'] != null">{{Languages["Since Last Reset Date"]["TranslateLabel"]}}:</div>
        <div class="col-md-1 col-1" style="text-align: right;">-</div><span>{{leaveCode.YTDUsed | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
    </div>
    <hr />
    <div class="row font-weight-bold" style="margin-bottom: 12px;">
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Current Available'] == null">Current Available:</div>
        <div class="col-md-6 col-6" style="text-align: right;" *ngIf="Languages['Current Available'] != null">{{Languages["Current Available"]["TranslateLabel"]}}:</div>
        <div class="col-md-1 col-1"></div><span>{{leaveCode.ViewpointBalance | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
    </div>


    <!-- New values -->

    <div *ngIf="!disableProjected && leaveCode.IsProjectable">
        <div class="row" style="margin-bottom: 12px;">
            <div class="col-md-6 col-6" style="text-align: right;">Projected Date Used:<span><i style="font-size:1.1em; cursor:pointer;" placement="top" ngbPopover="Date selected in the Project Hours as of  Date selector" class="modus-icons">info</i></span></div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{displayDate}}</span><br />
        </div>
        <div class="row" style="margin-bottom: 12px;">
            <div class="col-md-6 col-6" style="text-align: right;">Working Days from last accrual to projected date:</div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{dateDiff}}</span><br />
        </div>
        <div class="row" style="margin-bottom: 12px;">
            <div class="col-md-6 col-6" style="text-align: right;">Rate of Accrual per working Hours:<span><i style="font-size:1.1em; cursor:pointer;" placement="top" ngbPopover="The rate of accrual per working hour is calculated based on Accrual Rate / working day hours per Accrual period assuming a 5 day work week" class="modus-icons">info</i></span></div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{accrualRate}}</span><br />
        </div>
        <div class="row" style="margin-bottom: 12px;">
            <div class="col-md-6 col-6" style="text-align: right;">Total Projected Accrued:</div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{totalAccruedFromDateLastUsed | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
        </div>
        <div class="row" style="margin-bottom: 12px;">
            <div class="col-md-6 col-6" style="text-align: right;">Planned vacation Used:</div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{leaveCode.PlannedHours | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
        </div>
        <div class="row">
            <div class="col-md-6 col-6" style="text-align: right;">Total Projected:</div>
            <div class="col-md-1 col-1" style="text-align: right;"></div><span>{{leaveCode.CalculatedBalance | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</span><br />
        </div>
    </div>

    <!-- @*<hr />
    <div class="row">
        <div class="col-md-8 col-8" >Accrual Rate:</div>
        <div class="col-md-1 col-1"></div><span>{{leaveCode.AccrualRate | daysAndHours:'settings.TimeOffUnits':stdWorkdayHours}}</span><br />
    </div>
    <div class="row">
        {{leaveCode.AnnualAllotment | daysAndHours:'settings.TimeOffUnits':stdWorkdayHours}} / {{leaveCode.FixedUnits || 1}} / {{leaveCode.DefaultWorkHours}}
    </div>
    <div class="row">
        Current Balance as of {{displayDate}} - {{leaveCode.CalculatedBalance | daysAndHours:'settings.TimeOffUnits':stdWorkdayHours}}
    </div>
    <div class="row">
        Days since accrual:
    </div>*@ -->
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] == null">
        Cancel
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()" *ngIf="Languages['Cancel'] != null">
        {{Languages["Cancel"]["TranslateLabel"]}}
    </button>
</div>